import { format } from "date-fns";
import {
  PurchasesOrderItem,
  SuccessfulPurchase,
} from "../../../domain/usecases/get-account-balances";
import { currencyFormatter } from "../../utils/helpers";

type Props = {
  transaction: PurchasesOrderItem;
};

export default function ElectricityRow({ transaction }: Props) {
  const response = transaction.response as SuccessfulPurchase;
  const receipt = response?.creditVendReceipt ?? null;

  return (
    <tr className="bg-white">
      <td className="pr-6 py-3 text-left whitespace-nowrap text-sm text-gray-900 font-bold">
        {transaction.dateUpdated
          ? format(new Date(transaction.dateUpdated), "yyyy-MM-dd")
          : "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.receiptNo ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.meterNumber ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.name ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.stsCipher ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.tokenUnits ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {receipt?.ti ?? receipt?.tariff ?? "-"}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {currencyFormatter(receipt?.costUnits)}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {currencyFormatter(receipt?.governmentLevy)}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {currencyFormatter(receipt?.standardCharge)}
      </td>
      <td className="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
        {currencyFormatter(receipt?.vat)}
      </td>
      <td className="px-6 py-3 text-right whitespace-nowrap text-sm text-gray-900 font-bold">
        {currencyFormatter(receipt?.amtTendered)}
      </td>
    </tr>
  );
}
